import {
  PDF_VIEWER_SELECTION_AREA_BOX_HEIGHT,
  PDF_VIEWER_SELECTION_AREA_BOX_WIDTH,
} from './PdfViewerSelectionAreaBox.constants'

export function getPdfViewerSelectionAreaBoxInitValues({ x, y }) {
  return {
    height: PDF_VIEWER_SELECTION_AREA_BOX_HEIGHT,
    width: PDF_VIEWER_SELECTION_AREA_BOX_WIDTH,
    x,
    y,
  }
}
